var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcloudGradientLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.143,
    height: 34.285
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pcloud-gradient-logo_svg__a",
    x1: 0.382,
    y1: 0.068,
    x2: 0.601,
    y2: 0.868,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3fd0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17bed0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 953",
    d: "M44.782 34.285H12.638A12.668 12.668 0 010 21.591a12.373 12.373 0 0110.775-12.54 15.421 15.421 0 00-1.25 6h.113a17.056 17.056 0 0133.875 0h.108a16.312 16.312 0 00-1.354-6.07 4.538 4.538 0 01.723-.038 7.147 7.147 0 017.14 7.169 7.153 7.153 0 01-3.877 6.374 7.209 7.209 0 003.806-3.344 8.275 8.275 0 013.084 6.566 8.549 8.549 0 01-8.36 8.561v.012zM26.571 3.394a13.548 13.548 0 00-9.645 4.028 13.809 13.809 0 000 19.444 13.559 13.559 0 0019.291 0 13.809 13.809 0 000-19.444 13.548 13.548 0 00-9.645-4.028zm0 25.833a12.083 12.083 0 1111.987-12.083 12.049 12.049 0 01-11.987 12.083zm-3.714-19.6a2.133 2.133 0 00-2.1 2.126v11.101a2.126 2.126 0 004.252 0v-2.269h3.868a5.482 5.482 0 000-10.96H22.86zm5.886 7.168H25v-3.378h3.738a1.687 1.687 0 110 3.373z",
    transform: "translate(.001 -.001)",
    fill: "url(#pcloud-gradient-logo_svg__a)"
  })));
}
export default SvgPcloudGradientLogo;